import { createFileRoute } from '@tanstack/react-router'
import { FileText } from 'lucide-react'
import { MemoryDetailScreen } from '@/screens/workspace/SCR-004-memory-detail'

function DetailRoute() {
  const { memoryId } = Route.useParams()
  return <MemoryDetailScreen key={memoryId} memoryId={memoryId} />
}

export const Route = createFileRoute('/_app/w/$ws/memories_/$memoryId')({
  staticData: { screen: {"id":"SCR-004","title":"Memory detail","group":"Workspace","perm":"memory.read","hidden":true,"description":"One fact with its evidence, validity, visibility, history and use.", icon: FileText } },
  component: DetailRoute,
})
